/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { 
  FiRefreshCw, 
  FiSearch, 
  FiFilter, 
  FiGrid,
  FiList,
  FiUsers,
  FiDollarSign,
  FiTrendingUp,
  FiTrendingDown,
  FiClock,
  FiCheckCircle,
  FiXCircle,
  FiAlertCircle,
  FiUser,
  FiMail,
  FiCalendar,
  FiTag,
  FiArrowUp,
  FiArrowDown,
  FiBarChart2,
  FiAward,
  FiStar
} from "react-icons/fi";
import { 
  MdOutlinePayments, 
  MdOutlineAccountBalance,
  MdOutlineAttachMoney,
  MdOutlinePerson,
  MdOutlineCalendarToday,
  MdOutlineCheckCircle,
  MdOutlineCancel,
  MdOutlinePending,
  MdOutlineRefresh,
  MdOutlineSearch,
  MdOutlineFilter,
  MdOutlineReceipt,
  MdOutlineWallet
} from "react-icons/md";
import { IoWalletOutline, IoCashOutline, IoCardOutline, IoTimeOutline } from "react-icons/io5";
import ReferalTable from "./Table/ReferalTable";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  getAllWithdrawalList,
  paymentModeUserWithdrawal,
  updateUserWithdrawalStatus,
} from "../../Redux/teacherWithdrawalSlice";
import { useNavigate } from "react-router";

const TeachersSubscription = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selector = useSelector((state) => state);
  const {
    teachersWithdrawal: {
      withdrawalListData = [],
      withdrawalListTotal = 0,
    } = {},
  } = selector || {};

  const [keyword, setKeyword] = useState("");
  const referralThead = [
    { label: "#id", sortKey: null },
    { label: "User", sortKey: "userInfo.fullName" },
    { label: "Balance", sortKey: "availableBalance" },
    { label: "Pending Balance", sortKey: "pendingBalance" },
    { label: "Payment Provider", sortKey: "isStripeVerified" },
    { label: "Status", sortKey: "isBlocked" },
    { label: "Date", sortKey: "createdAt" },
    { label: "Action", sortKey: null },
  ];

  const [sortKey, setSortKey] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");

  const handleSort = (key) => {
    if (sortKey === key) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortKey(key);
      setSortOrder("asc");
    }
    setpageNo(1);
  };

  const [pageNo, setpageNo] = useState(1);
  const [size, setSize] = useState(10);

  const [isDisable, setIsDisable] = useState("");
  const [payoutMode, setPayoutMode] = useState("");

  let payload = {
    pageNo: pageNo,
    size: size,
    keyWord: keyword ? keyword : "",
    isBlocked: isDisable,
    payoutMode: payoutMode,
    sortKey: sortKey,
    sortOrder: sortOrder
  };

  const handleFilter = (e) => {
    setIsDisable(e.target.value);
    setpageNo(1);
  };

  const handleFilter1 = (e) => {
    setPayoutMode(e.target.value);
    setpageNo(1);
  };

  const viewAction = (item) => {
    navigate(`/app/teachers-withdrawal/${item?.userId}`);
  };

  useEffect(() => {
    dispatch(getAllWithdrawalList(payload));
  }, [dispatch, keyword, pageNo, size, isDisable, payoutMode, sortKey, sortOrder]);

  let handlePageClick = (newPage) => {
    setpageNo(newPage?.selected + 1);
  };

  const handleToggle = (data) => {
    let togglePayload = {
      id: data?._id,
    };
    dispatch(
      updateUserWithdrawalStatus({
        Payload: togglePayload,
        forReferesh: payload,
      }),
    )
      .then((res) => {
        toast.success(res?.message || "Updated Successful");
      })
      .catch((error) => {
        toast.error(error?.message || "Something went wrong");
      });
  };

  const handleChange = async (value, data) => {
    try {
      const reqData = {
        id: data?._id,
        payoutMode: value,
      };
      const res = await dispatch(
        paymentModeUserWithdrawal({ Payload: reqData, isRefresh: payload }),
      ).unwrap();
      toast.success(res?.message || "Updated Successful");
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  // Calculate statistics
  const totalWithdrawals = withdrawalListTotal || 0;
  const pendingWithdrawals = withdrawalListData?.filter(w => w?.status === 'pending')?.length || 0;
  const approvedWithdrawals = withdrawalListData?.filter(w => w?.status === 'approved' || w?.status === 'completed')?.length || 0;
  const rejectedWithdrawals = withdrawalListData?.filter(w => w?.status === 'rejected' || w?.status === 'failed')?.length || 0;
  
  // Calculate total amounts
  const totalBalance = withdrawalListData?.reduce((sum, w) => sum + (w?.balance || 0), 0) || 0;
  const totalPendingBalance = withdrawalListData?.reduce((sum, w) => sum + (w?.pendingBalance || 0), 0) || 0;

  // Stats cards data
  const statsCards = [
    {
      title: 'Total Withdrawals',
      count: totalWithdrawals,
      icon: MdOutlineReceipt,
      color: 'from-blue-500 to-blue-600',
      subtitle: 'All withdrawal requests'
    },
    // {
    //   title: 'Pending',
    //   count: pendingWithdrawals,
    //   icon: MdOutlinePending,
    //   color: 'from-amber-500 to-amber-600',
    //   subtitle: 'Awaiting approval'
    // },
    // {
    //   title: 'Approved',
    //   count: approvedWithdrawals,
    //   icon: MdOutlineCheckCircle,
    //   color: 'from-emerald-500 to-emerald-600',
    //   subtitle: 'Approved requests'
    // },
    // {
    //   title: 'Rejected',
    //   count: rejectedWithdrawals,
    //   icon: MdOutlineCancel,
    //   color: 'from-rose-500 to-rose-600',
    //   subtitle: 'Rejected requests'
    // }
  ];

  return (
    <div className="min-h-screen bg-gray-50/80">
      {/* Header Banner */}
      <div className="bg-gradient-to-r from-[#855DF6] via-[#7B5CF6] to-[#715EFE] shadow-lg relative overflow-hidden">
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-20 -mt-20 animate-pulse"></div>
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full -ml-12 -mb-12 animate-pulse"></div>
        <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2 animate-pulse"></div>
        
        <div className="relative z-10 px-4 md:px-7 py-6 md:py-8">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="p-2.5 bg-white/20 rounded-xl backdrop-blur-sm shadow-lg">
                <MdOutlineWallet className="w-5 h-5 text-white md:w-6 md:h-6" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-white md:text-2xl dahboardFont tracking-tight">
                  Teachers Withdrawal
                </h2>
                <p className="text-sm text-white/70 hidden sm:block">
                  Manage teacher withdrawal requests
                </p>
              </div>
            </div>
            {/* <div className="flex items-center gap-2">
              <div className="flex items-center gap-2 px-3 py-1.5 bg-white/20 rounded-full backdrop-blur-sm">
                <FiRefreshCw className="w-3.5 h-3.5 text-white/70" />
                <span className="text-xs text-white/80">
                  {new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                </span>
              </div>
            </div> */}
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-2 gap-3 mt-5 sm:grid-cols-4 md:gap-4">
            {statsCards.map((card, index) => (
              <div 
                key={index}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300 group"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-lg font-bold text-white uppercase md:text-lg">
                      {card.title}
                    </p>
                    <p className="text-xl font-bold text-white md:text-2xl mt-0.5">
                      {card.count}
                    </p>
                    {card.subtitle && (
                      <p className="text-[14px] text-white/40 hidden sm:block">
                        {card.subtitle}
                      </p>
                    )}
                  </div>
                  <div className={`p-2 rounded-xl bg-gradient-to-br ${card.color} bg-opacity-30 shadow-inner`}>
                    <card.icon className="w-4 h-4 text-white md:w-5 md:h-5" />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Summary Row */}
          {/* <div className="grid grid-cols-2 gap-3 mt-4 sm:grid-cols-2 md:gap-4">
            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-2 md:p-3 border border-white/10">
              <p className="text-[10px] font-medium text-white/50 uppercase tracking-wider">Total Balance</p>
              <p className="text-lg font-bold text-emerald-300 md:text-xl">${totalBalance.toFixed(2)}</p>
            </div>
            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-2 md:p-3 border border-white/10">
              <p className="text-[10px] font-medium text-white/50 uppercase tracking-wider">Pending Balance</p>
              <p className="text-lg font-bold text-amber-300 md:text-xl">${totalPendingBalance.toFixed(2)}</p>
            </div>
          </div> */}
        </div>
      </div>

      {/* Main Content */}
      <section className="px-3 py-4 -mt-4 md:px-6 lg:px-10 md:py-6">
        <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
          <div className="p-3 md:p-4">
            <ReferalTable
              TableName={`Teachers Withdrawal List`}
              TableHeader={referralThead}
              TableData={withdrawalListData}
              handleToggle={handleToggle}
              keyword={keyword}
              setKeyword={setKeyword}
              pageNo={pageNo}
              setpageNo={setpageNo}
              viewAction={viewAction}
              size={size}
              total={withdrawalListTotal}
              setSize={setSize}
              handlePageClick={handlePageClick}
              handleChange={handleChange}
              handleFilter={handleFilter}
              handleFilter1={handleFilter1}
              currentSortKey={sortKey}
              currentSortOrder={sortOrder}
              onSort={handleSort}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default TeachersSubscription;